<template>
  <div>
    <div>
      <div class="trainInfo">
        <div class="title">车次信息</div>
        <a-row class="main">
          <a-col :span="13">
            <div class="top">{{ orderDetail.fromTimeFormat }} 出发</div>
            <a-row class="box">
              <a-col :span="8">
                <div class="time">{{ orderDetail.fromTime }}</div>
                <div class="city">{{ orderDetail.fromStation }}</div>
              </a-col>
              <a-col :span="8" class="maiddle">
                <div class="runTime">
                  {{ orderDetail.takeTimeFormat }}
                  <img src="@assets/img/idcard.png" />
                </div>
                <img src="@assets/img/cardline.png" />
                <div class="trainNo">{{ orderDetail.trainNo }}</div>
              </a-col>
              <a-col :span="8" class="right">
                <div class="time">{{ orderDetail.toTime }}</div>
                <div class="city">{{ orderDetail.toStation }}</div>
              </a-col>
            </a-row>
            <!-- <div class="bottom">
                          <span>55</span>
                      </div> -->
          </a-col>
          <a-col :span="11" class="loading_cont"> </a-col>
        </a-row>
      </div>

      <div class="passengerInfo">
        <a-row class="title">
          <a-col :span="12">
            <div class="title-left">乘客信息</div>
          </a-col>
        </a-row>
        <a-row class="main">
          <a-col :span="4" class="name">
            {{ passenger.passengerName }}
          </a-col>
          <a-col :span="4" class="type">{{
            passenger.passengerTypeValue
          }}</a-col>
          <a-col :span="7">
            {{ passenger.seatName }}
            {{ passenger.lastCoach }}
            {{ passenger.lastSeat }}
          </a-col>
          <a-col :span="4">
            <span
              v-if="
                passenger.state == 10 ||
                passenger.state == 20 ||
                passenger.state == 30 ||
                passenger.state == 40
              "
              >{{ passenger.stateValue }}</span
            >
            <span v-else>正常票</span>
          </a-col>
          <a-col :span="5" class="price"
            >¥{{ passenger.ticketLastPrice }}</a-col
          >
        </a-row>
        <div
          style="color: #fd5739; padding-left: 21px; margin-top: 20px"
          v-if="orderDetail.haveChildren"
        >
          本次订单关联儿童票将一同做退票处理
        </div>
      </div>
      <!-- 保险 -->
      <div
        class="passengerInfo insurance"
        v-if="
          orderDetail.orderPassengersInsurance &&
          orderDetail.orderPassengersInsurance.length > 0
        "
      >
        <a-row class="title">
          <a-col :span="24">
            <div class="title-left">保险信息</div>
          </a-col>
        </a-row>
        <a-row
          class="main"
          v-for="(data, dataIndex) in orderDetail.orderPassengersInsurance"
          :key="dataIndex"
            :class="{
              grayClass: data.returnState >= 30 || data.insuranceState >= 31,
            }"
        >
          <a-col :span="4" class="name">
            {{ data.orderPassengerName }}
          </a-col>
          <a-col :span="4" class="name">{{ data.insuranceName }}</a-col>
          <a-col :span="10">
            保单：
            {{ data.insureNo }}
          </a-col>
          <a-col
            :span="3"
            class="price"
            v-if="data.insuranceState !== 31"
            style="color: #ff0000"
          >
            <span>{{ data.stateValue }}</span>
          </a-col>
          <a-col :span="3" class="price" v-else style="color: #f7b500">
            <WarningOutlined style="margin-right: 2px" />
            <span>{{ data.stateValue }}</span>
          </a-col>
          <a-col :span="3" class="price regular">
            ¥{{ data.insuranceAmount }}
          </a-col>
        </a-row>
      </div>
    </div>

    <div class="money_content">
      <div>
        <div class="price">
          <div>原票价</div>
          <div class="light">¥{{ orderDetail.originalPrice }}</div>
        </div>
        <div class="price">
          <div>手续费</div>
          <div class="light">¥{{ orderDetail.returnAmount }}</div>
        </div>
        <div class="price">
          <div>保险服务</div>
          <div class="light">¥{{ orderDetail.insuranceAmount }}</div>
        </div>

        <div class="price_totle">
          <div>约计退款</div>
          <div style="color: #fd5739">¥{{ orderDetail.estimatedPrice }}</div>
        </div>
      </div>
    </div>

    <div class="confirm_order">
      <a-button type="primary" class="submitBtn" @click="confirmOrder">
        确认退票
      </a-button>
      <a-button type="primary" class="concelBtn" @click="cancelOrder">
        取消退票
      </a-button>
    </div>
  </div>
</template>
<script>
import { ref, watch } from 'vue'
import commonApi from '@axios/common'
import { useRouter, useRoute } from 'vue-router'
import homeApi from '@axios/home'
import { Modal, message } from 'ant-design-vue'
import { WarningOutlined } from '@ant-design/icons-vue'
let timer
export default {
  name: 'orderRefund',
  components: {
    WarningOutlined

  },
  setup () {
    let router = useRouter()
    const route = useRoute()

    // 获取退票详情

    let orderCode = route.query.orderCode
    let passengerId = route.query.passenger

    let orderDetail = ref({})
    let passenger = ref({})

    const getDetail = () => {
      let params = {
        orderCode: orderCode,
        passengerId: passengerId
      }
      homeApi.getRefundDetail(params).then((res) => {
        orderDetail.value = res
        passenger.value = res.passengers
      })
    }

    getDetail()

    const confirmOrder = () => {
      Modal.confirm({
        content: '确定退票？',
        onOk () {
          let params = {
            orderCode: orderCode,
            passengerId: passengerId
          }
          homeApi.refund(params).then((res) => {
            router.replace({
              name: 'orderDetail',
              query: {
                orderCode: orderCode
              }
            })
          })
        },
        cancelText: "取消",
        okText: "确定",
        onCancel () {
          Modal.destroyAll()
        },
      })

    }

    const cancelOrder = () => {
      router.back()
    }


    return {
      cancelOrder,
      confirmOrder,
      orderDetail,
      passenger,
    }
  },

}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.light {
  font-family: PingFangSC-Light, PingFang SC;
  font-weight: 300;
}
.money_content {
  display: flex;
  justify-content: flex-end;
  margin-top: 40px;

  .price,
  .price_totle {
    display: flex;
    width: 335px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    justify-content: space-between;
    line-height: 30px;
    border-bottom: 0.5px dashed #bdc0c8;
    padding: 5px 0;
  }
  .price {
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #000000;
  }
  .price_totle {
    border: none;

    font-size: 14px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #000000;
  }
}
.totle_price {
  font-size: 16px;
  font-family: PingFangSC-Semibold, PingFang SC;
  font-weight: 600;
  color: #000000;
}
.regular {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
}
.confirm_order {
  margin-top: 70px;
  display: flex;
  justify-content: flex-end;
  .submitBtn,
  .concelBtn {
    width: 167px;
    height: 40px;
    border-radius: 4px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    line-height: 22px;
    font-size: 16px;
  }
  .submitBtn {
    background: #ffab00;
    border-color: #ffab00;
    margin-right: 17px;
  }
  .concelBtn {
    background: #f8f8f8;
    border-color: #f8f8f8;
    color: #000000;
    font-family: PingFangSC-Regular, PingFang SC;
  }
}

.loading_cont {
  ::v-deep(.ant-btn.ant-btn-loading)::before {
    display: none !important;
  }
}

.loading_btn {
  background: #ffab00;
  border-color: #ffab00;
  width: 125px;
  height: 35px;
  cursor: wait;
}
.loading_cont {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.endorse_cont {
  margin-top: 100px;
}
.grayClass {
  color: #dedfe3 !important;
  .price,
  .type {
    color: #dedfe3 !important;
  }
}
.name {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  font-family: PingFangSC-Medium, PingFang SC;
  span {
    margin-right: 10px;
  }
}
.orderDetail {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 15px;
  box-sizing: border-box;
  font-size: 14px;
}
.topTitle {
  line-height: 20px;
  margin-bottom: 20px;
  span {
    margin: 0 2px;
  }
}

.trainInfo {
  border: 0.5px solid #cdcccd;
  .title {
    height: 68px;
    line-height: 68px;
    font-size: 16px;
    padding-left: 26px;
    border-bottom: 0.5px solid #cdcccd;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
  }
  .main {
    padding: 15px 33px;
    display: flex;
    justify-content: flex-start;
    height: 180px;

    .ant-col-13 {
      border-right: 0.5px solid #cdcccd;
      .top {
        font-size: 16px;
        line-height: 22px;
        margin-bottom: 9px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #000000;
      }
      .box {
        padding-right: 40px;
        .time {
          line-height: 28px;
          margin-bottom: 8px;

          font-size: 20px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: #000000;
        }
        .city {
          line-height: 22px;

          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
        }
        .maiddle {
          text-align: center;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          & > img {
            width: 95px;
          }
          .runTime {
            font-size: 14px;
            line-height: 20px;
            color: #000000;

            font-family: PingFangSC-Light, PingFang SC;
            img {
              width: 17px;
              position: relative;
              top: -1px;
            }
          }
          .trainNo {
            line-height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #fd5839;
          }
        }
        .right {
          text-align: right;
        }
      }
      .bottom {
        padding-right: 40px;
        text-align: right;
        margin-top: 18px;
        span {
          font-size: 12px;
          color: #3999fb;
          border: 0.5px solid #3999fb;
          border-radius: 10px;
          padding: 1px 8px;
        }
      }
    }
    .ant-col-11 {
      padding: 31px 47px;
      .item {
        line-height: 26px;
        margin-bottom: 8px;
        .price {
          text-align: right;
          font-size: 16px;
          font-family: PingFangSC-Light, PingFang SC;
          font-weight: 300;
          color: #000000;
        }
      }
    }
  }
}
.passengerInfo {
  background: rgba(248, 248, 248, 1);
  padding: 20px 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  .title {
    padding-right: 47px;
    .title-left {
      font-size: 16px;
      line-height: 22px;
      padding: 0 21px;
      margin-bottom: 18px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000000;
    }
    .title-right {
      text-align: right;
      .change {
        font-size: 14px;
        cursor: pointer;
      }
      .line {
        margin: 0 20px;
        color: rgba(0, 0, 0, 0.35);
      }
      .choosed {
        color: #ffab00;
        text-decoration: underline;
      }
      .refund {
        cursor: pointer;
      }
    }
  }
  .main {
    padding: 5px 47px 5px 21px;
    // height: 40px;
    line-height: 40px;
    font-size: 16px;
    border-bottom: 0.5px dashed rgba(189, 192, 200, 0.5);
    font-family: PingFangSC-Light, PingFang SC;
    font-weight: 300;
    color: #000000;
    &:last-of-type {
      border-bottom: none;
    }
    .type {
      font-size: 14px;
      color: #6d7278;
    }
    .price {
      text-align: right;
      color: #ff0000;

      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
    }
  }
}
.insurance {
  background: #ffffff;
  padding: 15px 10px;
  .title {
    .title-left {
      font-size: 14px;
      line-height: 20px;
      margin-bottom: 0;
    }
  }
  .main {
    line-height: 30px;
    font-size: 14px;
  }
}
.noendorse {
  color: #dedfe3 !important;
}
.bottomInfo {
  text-align: right;
  margin: 20px 0 60px 0;
  .handleBtn {
    display: inline-block;
    padding: 9px 50px;
    background: #ffab00;
    font-size: 16px;
    color: #ffffff;
    border-radius: 4px;
    cursor: pointer;
  }
}
</style>
